<template>
    <div>
        <block-header
            :image="activity.headerImage"
            :web-p-image="activity.headerImageWebP"
            :title="activity.title"
        ></block-header>
        <section>
            <div class="container">
                <div v-if="loading" class="row">
                    <div class="col-12" style="text-align: center">
                        <spinner />
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col-12 col-lg-8 intro-block mb-4">
                        <block-text
                            v-if="activity.intro"
                            class="rte"
                            :activity="activity"
                        ></block-text>
                        <div class="bg-white py-1 mt-4">
                            <section class="activity-program">
                                <div class="container position-relative">
                                    <activity-icons
                                        :activity="activity"
                                    ></activity-icons>
                                    <div
                                        v-if="activity.body !== ''"
                                        class="row"
                                    >
                                        <div
                                            class="col-12 col-md-10 offset-md-1"
                                        >
                                            <h2 class="text-center mb-5">
                                                Programma en lesmateriaal
                                            </h2>
                                            <div v-html="activity.body"></div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <activity-materials
                                :activity="activity"
                            ></activity-materials>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 sidebar">
                        <div class="sidebar--sticky align-self-start">
                            <a
                                v-if="registrationUrl != '' && showSignupButton"
                                :href="registrationUrl"
                                class="btn mb-4 mt-2 w-100 btn--secondary"
                            >
                                <span v-if="registrationUrl != ''">
                                    Reserveren
                                    <i
                                        class="fa fa-arrow-right ml-2"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            </a>
                            <activity-info
                                :activity="activity"
                                :show-dates="showSignupButton"
                                class="mb-4"
                            ></activity-info>
                            <activity-location
                                v-if="showSignupButton"
                                class="mb-4"
                                :activity="activity"
                            ></activity-location>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-white py-1">
            <activity-imagery
                title="Foto's en beeldmateriaal"
                :activity="activity"
            ></activity-imagery>
        </section>
        <subsequent-activities
            :activities-inside-list="
                activity.relatedActivitiesInsideSchoolTimes
            "
            :activities-outside-list="
                activity.relatedActivitiesOutsideSchoolTimes
            "
        ></subsequent-activities>
    </div>
</template>

<script>
import axios from 'axios';
import blockHeader from '@/components/blocks/block-header';
import blockText from '@/components/blocks/block-text';
import activityInfo from '@/components/blocks/activity-info';
import activityLocation from '@/components/blocks/activity-location';
import activityImagery from '@/components/blocks/activity-imagery';
import subsequentActivities from '@/components/subsequent-activities';
import activityMaterials from '@/components/blocks/activity-materials';
import activityIcons from '@/components/blocks/activity-icons';
import spinner from '@/components/spinner';
export default {
    components: {
        blockHeader,
        blockText,
        activityInfo,
        activityLocation,
        activityImagery,
        subsequentActivities,
        activityMaterials,
        activityIcons,
        spinner
    },
    props: {
        activityId: {
            type: Number,
            default: -1
        },
        providerId: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            loading: false,
            activity: {},
            registrationUrl: '',
            infoRequestUrl: '',
            showSignupButton: false
        };
    },
    created() {
        this.getActivity();
    },
    mounted() {},
    methods: {
        getActivity() {
            this.loading = true;
            axios
                .get('/w3subookings/activity/get', {
                    params: {
                        activityId: this.activityId
                    }
                })
                .then(response => {
                    this.activity = response.data;
                    this.showSignupButton = this.activity.schedule.length > 0;
                })
                .finally(() => {
                    this.loading = false;
                    this.getRegistrationUrl();
                });
        },
        getRegistrationUrl() {
            if (
                this.activity.registrationRedirectURL != null &&
                this.activity.registrationRedirectURL != undefined &&
                this.activity.numberOfLessons > 15
            ) {
                this.registrationUrl = this.activity.registrationRedirectURL;
            } else {
                this.registrationUrl =
                    this.activity.registrationUrl +
                    '?activityId=' +
                    this.activityId +
                    '&providerId=' +
                    this.providerId;
            }
            this.activity.infoRequestUrl =
                this.activity.userInfoRequestUrl +
                '?activityId=' +
                this.activityId +
                '&providerId=' +
                this.providerId;
        }
    }
};
</script>

<style lang="scss">
.activity-program .row {
    overflow-wrap: break-word;
}
</style>
